// Redux
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

// Types
import environment from '../../config';
import { RootState } from '../store';
import {
  ICreateNewCategoryData,
  ICreateNewCategoryResponse,
  IGetAllCategoriesPrivateData,
  IGetAllCategoriesPrivateResponse,
  IGetCategoryByIdResponse,
  IUpdateCategoryByIdData,
  IUpdateCategoryByIdResponse,
} from './pagesCategoryTypes';

export const pagesCategoryApi = createApi({
  reducerPath: 'pagesCategoryApi',

  baseQuery: fetchBaseQuery({
    baseUrl: `${environment.BASE_URL}/static-pages/category`,
    prepareHeaders: (headers, { getState }) => {
      const accessToken = (getState() as RootState).auth.tokens.accessToken;

      if (accessToken) {
        headers.set('Authorization', `Bearer ${accessToken}`);
      }

      headers.set('x-api-key', environment.API_KEY);

      return headers;
    },
  }),

  endpoints: builder => ({
    createNewCategory: builder.mutation<
      ICreateNewCategoryResponse,
      ICreateNewCategoryData
    >({
      query: categoryData => {
        return {
          url: `/`,
          method: 'POST',
          body: categoryData,
        };
      },
    }),

    updateCategoryById: builder.mutation<
      IUpdateCategoryByIdResponse,
      IUpdateCategoryByIdData
    >({
      query: ({ categoryId, categoryData }) => {
        return {
          url: `/${categoryId}`,
          method: 'PATCH',
          body: categoryData,
        };
      },
    }),

    getAllCategoriesPrivate: builder.query<
      IGetAllCategoriesPrivateResponse,
      IGetAllCategoriesPrivateData
    >({
      query: params => ({
        url: '',
        params,
      }),
    }),

    getCategoryById: builder.query<IGetCategoryByIdResponse, string>({
      query: categoryId => `/${categoryId}`,
    }),

    deleteCategoryById: builder.mutation<any, string>({
      query: categoryId => {
        return {
          url: `/${categoryId}`,
          method: 'DELETE',
        };
      },
    }),
  }),
});

export const {
  useCreateNewCategoryMutation,
  useUpdateCategoryByIdMutation,
  useLazyGetAllCategoriesPrivateQuery,
  useLazyGetCategoryByIdQuery,
  useDeleteCategoryByIdMutation,
} = pagesCategoryApi;
